import React from 'react';
import {Nav, Logo, Header} from './StyledNavbar';
import Menu from '../menu/Menu';

const Navbar = ({links}) => (
    <Nav>
        <Header>
            <Logo to="/">Antiquoholics</Logo>
            <Menu links={links}/>
        </Header>
    </Nav>
);

export default Navbar;
